import WEAPONS from "../../consts/WEAPONS";
import WeaponType from "../../enums/WeaponType";
import BaseWeapon from "./BaseWeapon";
import PowerUpWeapon from "./PowerUpWeapon";
import BubbleWeapon from "./BubbleWeapon";
import StoneAuraWeapon from "./StoneAuraWeapon";

export default class WeaponFactory {
  GetWeapon(weapon: WeaponType): BaseWeapon {
    const weaponData = WEAPONS[weapon][0];
    if (weaponData.isPowerUp) {
      return new PowerUpWeapon(weapon);
    }
    switch (weapon) {
      default:
      case WeaponType.HASHBLADE:
        return new BaseWeapon(weapon);
      case WeaponType.BOOMERANG:
        return new BaseWeapon(weapon);
      case WeaponType.BLAST:
        return new BaseWeapon(weapon);
      case WeaponType.ROCK:
        return new BaseWeapon(weapon);
      case WeaponType.BUBBLE:
        return new BubbleWeapon(weapon);
      case WeaponType.STONEAURA:
        return new StoneAuraWeapon(weapon);
    }
  }
}
